// A report's or a run's state: colour, icon and the server's word. An unknown state is neutral.
import React from "react";
import Chip from "@mui/material/Chip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";

const GOOD = { color: "#4caf50", Icon: CheckCircleIcon };
const NEUTRAL = { color: "#757575", Icon: InfoIcon };
const LOOK = {
  active: GOOD,
  sent: GOOD,
  paused: { color: "#fe9f1b", Icon: PauseCircleIcon },
  failed: { color: "#bf3535", Icon: ErrorIcon },
};

export default function StatusChip({ state, label }) {
  const { color, Icon } = LOOK[state] || NEUTRAL;
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<Icon style={{ color }} />}
      label={label || state}
      style={{ color, borderColor: color }}
    />
  );
}
